const getEngagementMasterFormFields = (t, data = {}) => [
  {
    row: [
      {
        label: t("em_tab_requestId") || "Request ID",
        value: data.requestId || "2026",
        gridClass: "col-md-3",
      },
      {
        label: t("em_tab_serviceCatalogueId") || "Service Catalogue ID",
        value: data.serviceCatalogueId || "ATMT Amgen Inc",
        gridClass: "col-md-3",
      },
      {
        label: t("em_tab_serviceName") || "Service Name",
        value: data.serviceName || "--",
        gridClass: "col-md-3",
      },
      {
        label: t("em_tab_requestStatus") || "Request Status",
        value: data.requestStatus || "HTMT",
        gridClass: "col-md-3",
      },
    ],
  },
  {
    row: [
      {
        label: t("em_tab_clientCode") || "Client Code",
        value: data.clientCode || "66661234",
        gridClass: "col-md-3",
      },
      {
        label: t("em_tab_clientName") || "Client Name",
        value: data.clientName || "ATMT Amgen Inc",
        gridClass: "col-md-3",
      },
      {
        label: t("em_tab_workspaceName") || "Workspace Name",
        value: data.workspaceName || "--",
        gridClass: "col-md-3",
      },
      {
        label: t("em_tab_office") || "Office",
        value: data.office || "--",
        gridClass: "col-md-3",
      },
    ],
  },
  {
    row: [
      {
        label: t("em_tab_country") || "Country",
        value: data.country || "--",
        gridClass: "col-md-3",
      },
      {
        label: t("em_tab_region") || "Region",
        value: data.region || "--",
        gridClass: "col-md-3",
      },
      {
        label: t("em_tab_sector") || "Sector",
        value: data.sector || "--",
        gridClass: "col-md-3",
      },
      {
        label: t("em_tab_serviceLine") || "Service Line",
        value: data.serviceLine || "--",
        gridClass: "col-md-3",
      },
    ],
  },
  {
    row: [
      {
        label: t("em_tab_subServiceLine") || "Sub-Service Line",
        value: data.subServiceLine || "--",
        gridClass: "col-md-3",
      },
      {
        label: t("em_tab_engagementId") || "Engagement ID",
        value: data.engagementId || "--",
        gridClass: "col-md-3",
      },
      {
        label: t("em_tab_engagementName") || "Engagement Name",
        value: data.engagementName || "--",
        gridClass: "col-md-3",
      },
      {
        label: t("em_tab_archivedEngagementId") || "Archived Engagement ID",
        value: data.archivedEngagementId || "--",
        gridClass: "col-md-3",
      },
    ],
  },
  {
    row: [
      {
        label:
          t("em_tab_expectedEngagementHours") || "Expected Engagement Hours",
        value: data.expectedEngagementHours || "--",
        gridClass: "col-md-3",
      },
      {
        label: t("em_tab_engagementNature") || "Engagement Nature",
        value: data.engagementNature || "--",
        gridClass: "col-md-3",
      },
      {
        label: t("em_tab_entityType") || "Engagement Type",
        value: data.entityType || "--",
        gridClass: "col-md-3",
      },
      {
        label: t("em_tab_multiEntity") || "Multi Entity",
        value: data.multiEntity || "No",
        gridClass: "col-md-3",
      },
    ],
  },
  {
    row: [
      {
        label: t("em_tab_complexity") || "Complexity of entity",
        value: data.complexity || "--",
        gridClass: "col-md-3",
      },
      {
        label: t("rmq_industry") || "Industry",
        value: data.industry || "--",
        gridClass: "col-md-3",
      },
    ],
  },
];

export { getEngagementMasterFormFields };
